import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class ReportService {
  constructor() {
    this.$api = apiClient
  }

  getOperations (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/reports/operations${query}`)
  }

  getTurnovers (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/reports/turnovers${query}`)
  }

  getSales (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/reports/sales${query}`)
  }

  getSummarySales (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/reports/summary-sales${query}`)
  }

  getSummaryDelivery (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/reports/summary-delivery${query}`)
  }
}

export default new ReportService()
